/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Discover_Body_1Inputs */

const en_how_we_work_discover_body_1 = /** @type {(inputs: How_We_Work_Discover_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walk us through a recent example. We map the tools, people and handoffs, including the awkward cases that don’t fit the usual process.`)
};

const lv_how_we_work_discover_body_1 = /** @type {(inputs: How_We_Work_Discover_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izstāstiet nesenu piemēru. Mēs izkārtojam rīkus, cilvēkus un darba nodošanas punktus, tostarp neērtos gadījumus, kas neiekļaujas ierastajā procesā.`)
};

/**
* | output |
* | --- |
* | "Walk us through a recent example. We map the tools, people and handoffs, including the awkward cases that don’t fit the usual process." |
*
* @param {How_We_Work_Discover_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_discover_body_1 = /** @type {((inputs?: How_We_Work_Discover_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Discover_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_discover_body_1(inputs)
	return en_how_we_work_discover_body_1(inputs)
});